var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('hr'),_c('contactList'),_c('hr'),_c('AddContact')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"id":"title"}},[_vm._v("Контакты")])])}]

export { render, staticRenderFns }